import { Branding, BrandingStyle, DisabledPrompt } from "@bcm-dev/bcms-vite";
import CustomSelect, { CustomSelectItem } from "components/custom-ui/CustomSelect";
import { SVGAsset } from "res";

export default function TransactionSearchDownloadDropdown(props) {
    return (
        <CustomSelect className="download-dropdown" SelectedItem={ DownloadDropdownSelectedItem }>
            <DisabledPrompt>
                <Branding id="download_spreadsheet_abi22" value="true" default="true">
                    <CustomSelectItem>Spreadsheet</CustomSelectItem>
                </Branding>

                <Branding id="download_quicken_abi22" value="true" default="true">
                    <CustomSelectItem>Quicken</CustomSelectItem>
                </Branding>
            
                <Branding id="download_bai2_abi22" value="true" default="true">
                    <CustomSelectItem>BAI2</CustomSelectItem>    
                </Branding>
            </DisabledPrompt>
        </CustomSelect>
    );
}

function DownloadDropdownSelectedItem(props) {
    const { controller } = props ?? {};

    return (
        <BrandingStyle className="flex-container set-width align-center download clickable highlighted-text link" style={{"color" : "links_abi22"}} element={
            <div onClick={ controller.toggle }>
                <BrandingStyle style={{"fill" : "links_abi22"}} className="inline-text-icon left-icon" element={<SVGAsset id="DownloadArrowIcon" />}/>
                <p data-point="Download">Download</p>
            </div>
        }/>
    );
}